import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import { SpecialOrderDetail } from "../../types/special-order.type";
import { formatDate } from "../../utils/date";

const stamp = (at: string | null, by: string | null) => {
  if (!at) return undefined;
  const when = formatDate(at, "DD/MM/YYYY HH:mm");
  return by ? `${when} · ${by}` : when;
};

/** ร่าง → ยืนยันสั่ง → ยืนยันส่ง → เสร็จสิ้น, or ยกเลิก as the last step when cancelled. */
export default function StatusStepper({ order }: Readonly<{ order: SpecialOrderDetail }>) {
  const cancelled = order.status === "cancelled";
  const steps = [
    { label: "ร่าง", done: true, caption: stamp(order.created_at, order.created_by_name) },
    {
      label: "ยืนยันสั่ง",
      done: Boolean(order.confirmed_at) || order.status === "ordered" || order.status === "delivered",
      caption: stamp(order.confirmed_at, order.confirmed_by_name),
    },
    {
      label: "ยืนยันส่ง",
      done: Boolean(order.delivered_at) || order.status === "delivered",
      caption: stamp(order.delivered_at, order.delivered_by_name),
    },
    cancelled
      ? {
          label: "ยกเลิก",
          done: true,
          caption: stamp(order.cancelled_at, order.cancelled_by_name),
        }
      : { label: "เสร็จสิ้น", done: order.status === "delivered", caption: undefined },
  ];

  const activeStep = {
    draft: 0,
    ordered: 1,
    delivered: 4,
    cancelled: 3,
  }[order.status];

  return (
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((step, index) => {
        const isCancelStep = cancelled && index === 3;
        return (
          <Step key={step.label} completed={step.done && !isCancelStep}>
            <StepLabel
              error={isCancelStep}
              optional={
                step.caption ? (
                  <Typography variant="caption" color="text.secondary">
                    {step.caption}
                  </Typography>
                ) : undefined
              }
            >
              {step.label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
}
